export function definePropsString(argument?: string | null) {
    return argument || '';
}
